import React from "react";
import {Query} from "react-apollo";
import {GET_WAREHOUSE} from "../../queries/inventory";
import {GET_PARTNER} from "../../queries/partners";

// The ends of a stock movement, for the overview box at the top of a
// transfer, client dispatch or purchase order: a heading, a name, an address.

export const Place = ({title, name, lines, detail}) => (
  <div className="Place">
    <h4>{title}</h4>
    {name && <div className="name">{name}</div>}
    {(lines || []).filter((line) => line).map((line, i) => <div key={i} className="line">{line}</div>)}
    {detail && <div className="detail">{detail}</div>}
  </div>
);

function cityLine(postcode, city, stateProvince) {
  return [[postcode, city].filter((part) => part).join(" "), stateProvince].filter((part) => part).join(", ");
}

// One of our warehouses, with its address from Warehouses.
export const WarehousePlace = ({title, warehouseId}) => (
  <Query query={GET_WAREHOUSE} variables={{warehouseId}} skip={!warehouseId}>
    {({data}) => {
      const warehouse = data && data.warehouse;
      const address = (warehouse && warehouse.address) || {};
      return (
        <Place
          title={title}
          name={(warehouse && warehouse.companyName) || warehouseId}
          lines={[
            address.addressAddressLine1,
            address.addressAddressLine2,
            cityLine(address.addressPostcode, address.addressCity, address.addressStateProvince),
            address.addressCountryCode,
          ]}
          detail={warehouse && warehouse.companyName ? warehouseId : ""} />
      )
    }}
  </Query>
);

// A saved partner address (a client's delivery address, or a supplier's).
export function partnerAddressLines(address) {
  if (!address) return [];
  return [
    address.name,
    address.attName ? `Att. ${address.attName}` : "",
    address.addressLine1,
    address.addressLine2,
    cityLine(address.postcode, address.city, address.stateProvince),
    address.countryCode,
    address.phoneNr,
  ];
}

// The recipient on the address is left out when it is the name above it.
export const AddressPlace = ({title, name, address}) => (
  <Place
    title={title}
    name={name}
    lines={partnerAddressLines(address).filter((line) => line !== name)}
    detail={address && address.label ? address.label : ""} />
);

// A partner with its first saved address (a supplier, on a purchase order).
export const PartnerPlace = ({title, partnerId, name}) => (
  <Query query={GET_PARTNER} variables={{partnerId}} skip={!partnerId}>
    {({data}) => {
      const addresses = (data && data.partner && data.partner.addresses) || [];
      return <AddressPlace title={title} name={name} address={addresses[0]} />
    }}
  </Query>
);

// How the goods travel, and when they are expected.
export const TransportPlace = ({transportType, carrierReference, expectedDate, expectedLabel}) => (
  <Place
    title="Transport"
    name={[capitalize(transportType), carrierReference].filter((part) => part).join(" · ") || "Not set"}
    lines={[expectedDate ? `${expectedLabel || "Expected"} ${String(expectedDate).substr(0, 10)}` : ""]} />
);

function capitalize(value) {
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1);
}
